<template>
	<div
		class="inline-flex h-[22px] items-center rounded-full border px-2 py-0.5 text-sm"
		:style="{ borderColor: color, color: color }"
		:title="name"
	>
		<ColorCircle :color="color" class="mr-1.5" />
		<span class="max-w-[120px] truncate">{{ name }}</span>
	</div>
</template>

<script setup lang="ts">
	import ColorCircle from "@/components/ui/ColorCircle.vue";

	interface Props {
		name: string;
		color: string;
	}

	defineProps<Props>();
</script>
